<div [formGroup]="group">
  <div class="flex items-center gap-2 mb-2">
    <h3 class="text-sm font-medium">Shipping Address</h3>
    <ng-container *ngIf="checksEnabled">
      <span class="ship-status ship-status--muted" *ngIf="checking">
        <mat-spinner diameter="12"></mat-spinner> Checking with Easyship…
      </span>
      <span
        *ngIf="!checking && result"
        class="ship-status"
        [ngClass]="'ship-status--' + tone(result.status)"
        [matTooltip]="result.message"
      >
        <mat-icon>{{ result.status === 'DELIVERABLE' ? 'check_circle' : 'warning' }}</mat-icon>
        {{ statusLabel }}
      </span>
    </ng-container>
  </div>
  <div class="grid grid-cols-6 gap-2">
    <mat-form-field appearance="outline" class="col-span-3">
      <mat-label>Street</mat-label>
      <input
        matInput
        formControlName="street"
        [matAutocomplete]="streetSuggestions.panel"
        [matAutocompleteDisabled]="!streetSuggestions.active"
        (focus)="streetSuggestions.warmUp()"
        (input)="streetSuggestions.search($any($event.target).value)"
      />
    </mat-form-field>
    <app-address-suggestions
      #streetSuggestions
      [country]="group.value?.countryAlpha2"
      (picked)="applySuggestion($event)"
    ></app-address-suggestions>
    <mat-form-field appearance="outline" class="col-span-3">
      <mat-label>City</mat-label>
      <input matInput formControlName="city" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>State / Province</mat-label>
      <input matInput formControlName="stateOrProvince" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Postal Code</mat-label>
      <input matInput formControlName="postalCode" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Country</mat-label>
      <mat-select formControlName="countryAlpha2">
        <mat-option [value]="null">—</mat-option>
        <mat-option *ngFor="let c of countries" [value]="c.alpha2">{{ c.name }}</mat-option>
      </mat-select>
      <mat-hint *ngIf="legacyCountry">Previously entered: “{{ legacyCountry }}”</mat-hint>
    </mat-form-field>
  </div>
  <p class="ship-message" *ngIf="checksEnabled && !checking && result && result.status !== 'DELIVERABLE'">
    {{ result.message }}
    <ng-container *ngIf="result.status !== 'UNKNOWN'">The patient can still be saved.</ng-container>
  </p>
</div>
